import React from 'react';
import { OrderingWrapperProps } from './types';
import Layout from './Layout';

export function OrderingWrapper(props: OrderingWrapperProps) {
  return (
    <Layout {...props} />
  )
}
